import { mockComponent } from 'bloko/common/setupMockComponents';

const { LinkKind, LinkAppearance, LinkIconPosition } = jest.requireActual('bloko/blocks/link/index.js');
export { LinkKind, LinkAppearance, LinkIconPosition };

export default mockComponent('Link', null, {
    withChildren: true,
});
